/// <reference types="./withQueryPerformance.d.ts" />
export async function withQueryPerformance(context, text, callback) {
    const startTime = performance.now();
    let success = false;
    try {
        const result = await callback();
        success = true;
        const duration = performance.now() - startTime;
        context.databasePerformance?.onQueryCompleted(text, success, duration);
        return result;
    }
    finally {
        if (!success) {
            const duration = performance.now() - startTime;
            context.databasePerformance?.onQueryCompleted(text, success, duration);
        }
    }
}
//# sourceMappingURL=withQueryPerformance.js.map